import { Button, ButtonGroup } from "reactstrap";
import { ReactGlobals, TreeNode } from "../Types";
import backendService from "../../services/backend.service";
import { SetStateAction } from "react";

const NumberNode = (
  node: TreeNode,
  globals: ReactGlobals,
  load_node: (new_id: string, new_type: string) => void,
  handleTempContentChange: (event: {
    target: { value: SetStateAction<string> };
  }) => void
) => {
  let step = 1;

  node.Children.forEach((child: TreeNode) => {
    if (child.Name === "step") {
      step = +child.Content;
    }
  });

  return (
    <div key={Math.random().toString() + node.ID}>
      <ButtonGroup size="sm">
        {globals.isLoggedIn ? (
          <Button
            outline
            onClick={() => {
              backendService
                .change_content(node.ID, "" + (+node.Content - step))
                .then((res) => {
                  load_node(globals.node.ID, globals.node.Type);
                });
            }}
          >
            -{step}
          </Button>
        ) : (
          <></>
        )}
        <Button outline>
          {node.ID === globals.node.ID
            ? globals.temporaryContent
            : node.Content}
        </Button>
        {globals.isLoggedIn ? (
          <Button
            outline
            onClick={() => {
              backendService
                .change_content(node.ID, "" + (+node.Content + step))
                .then((res) => {
                  load_node(globals.node.ID, globals.node.Type);
                });
            }}
          >
            +{step}
          </Button>
        ) : (
          <></>
        )}
        <Button outline disabled>
          {node.ID === globals.node.ID ? globals.temporaryName : node.Name}
        </Button>
      </ButtonGroup>
    </div>
  );
};

export function add_Number_to_dicts(
  constuctor_dict: Map<
    string,
    (
      node: TreeNode,
      globals: ReactGlobals,
      load_node: (new_id: string) => void,
      handleTempContentChange: (event: {
        target: { value: SetStateAction<string> };
      }) => void
    ) => JSX.Element
  >,
  type_prompt_dict: Map<string, string[]>,
  type_adding_dict: Map<string, string[]>,
  type_depth_dict: Map<string, number>
) {
  constuctor_dict.set("Number", NumberNode);
  type_prompt_dict.set("Number", []);
  type_adding_dict.set("Number", ["Number"]);
  type_depth_dict.set("Number", 1);
}

export default NumberNode;
